// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"349":"d64b01e9","395":"90b65553"}[chunkId] + ".js";
};